"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startBufferingData = startBufferingData;
const observable_1 = require("../tools/observable");
const trackRuntimeError_1 = require("./error/trackRuntimeError");
const BUFFER_LIMIT = 500;
function startBufferingData(trackRuntimeErrorImpl = trackRuntimeError_1.trackRuntimeError) {
    const observable = new observable_1.BufferedObservable(BUFFER_LIMIT);
    const runtimeErrorSubscription = trackRuntimeErrorImpl().subscribe((error) => {
        observable.notify({
            type: 0 /* BufferedDataType.RUNTIME_ERROR */,
            error,
        });
    });
    return {
        observable,
        stop: () => {
            runtimeErrorSubscription.unsubscribe();
        },
    };
}
//# sourceMappingURL=bufferedData.js.map